// extracted by mini-css-extract-plugin
export var attachment = "_s6-a";
export var emailContainer = "_s6-4";
export var emailContentPaddedContainer = "_s6-b";
export var emailHeader = "_s6-6";
export var emailIframe = "_s6-3";
export var emailInfoIcon = "_s6-9";
export var emailShortenedSummary = "_s6-e";
export var infoDropdown = "_s6-0";
export var infoRowBoundedContent = "_s6-d";
export var internal = "_s6-5";
export var merchant = "_s6-8";
export var messageInputContainer = "_s6-h";
export var normal = "_s6-7";
export var replyCard = "_s6-f";
export var subtleButton = "_s6-1";
export var subtleButtonIconContainer = "_s6-2";
export var toggleViewRepliesButton = "_s6-c";
export var wrappingText = "_s6-g";